module.exports = __webpack_public_path__ + "logo.b96cf9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 860
// module chunks = 0